import { render, staticRenderFns } from "./MultipleType.vue?vue&type=template&id=04777e47&scoped=true"
import script from "./MultipleType.vue?vue&type=script&lang=js"
export * from "./MultipleType.vue?vue&type=script&lang=js"
import style0 from "./MultipleType.vue?vue&type=style&index=0&id=04777e47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04777e47",
  null
  
)

export default component.exports